export default [
  {
    path: '/student-transfers',
    name: 'student-transfer',
    meta: { requiresAuth: true },
    component: () => import('@/pages/student-transfer/index.vue')
  }
]
